import GoogleTagManager from 'react-gtm-module'

import { APP_CONFIG } from '../constants/appConfig'
import { getAppVersion } from './app/app.helpers'

const initGTM = () => {
  const gtmId = APP_CONFIG.GOOGLE_TAG_MANAGER_ID
  if (gtmId) {
    GoogleTagManager.initialize({
      gtmId,
      dataLayer: {
        platform: 'web',
        version: getAppVersion()
      },
      dataLayerName: 'dataLayer'
    })
  }
}

const pushDataLayer = (dataLayer, dataLayerName) => {
  if (APP_CONFIG.GOOGLE_TAG_MANAGER_ID) {
    GoogleTagManager.dataLayer({
      dataLayer,
      dataLayerName
    })
  }
}

export { initGTM, pushDataLayer }
